import React from "react";
import { useTranslation } from "react-i18next";

import "./maintenance.css";

const getFirstName = () => {
  try {
    return JSON.parse(localStorage.getItem("authTokens"))?.user_first_name;
  } catch {
    return undefined;
  }
};

const Maintenance = () => {
  const firstName = getFirstName();
  const { t } = useTranslation(["maintenance"]);

  return (
    <div className="maintenance">
      {/* <h1>{authTokens.user_first_name ? t('hi') + authTokens.user_first_name : t('hi_there')}, {t('im_upgrading')}</h1> */}
      <h1>
        {firstName ? t("hi") + firstName : t("hi_there")}
        !
      </h1>
      <h2>{t("maintenance_msg")}</h2>
      <h2>{t("will_be_back_by")}</h2>
      <svg
        width="762"
        height="762"
        viewBox="0 0 762 762"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="381"
          cy="381"
          r="370"
          fill="white"
          stroke="white"
          strokeWidth="22"
        />
        <path
          d="M144.533 453.557V647.067L614.238 647.096V453.557C614.238 397.62 594.822 346.267 562.43 305.819V172.029H562.451C562.451 139.727 536.398 113.546 504.246 113.546C472.087 113.546 446.021 139.727 446.021 172.029V227.312C424.907 221.042 402.541 217.616 379.396 217.616C356.237 217.616 333.885 221.035 312.757 227.312V172.029C312.757 139.727 286.69 113.546 254.546 113.546C222.394 113.546 196.327 139.727 196.327 172.029V305.826C163.949 346.267 144.533 397.62 144.533 453.557Z"
          fill="white"
        />
        <path
          d="M255.423 393.142C271.319 393.142 284.206 380.195 284.206 364.224C284.206 348.253 271.319 335.306 255.423 335.306C239.526 335.306 226.639 348.253 226.639 364.224C226.639 380.195 239.526 393.142 255.423 393.142Z"
          fill="#3D2BFF"
        />
        <path
          d="M503.383 393.142C519.28 393.142 532.167 380.195 532.167 364.224C532.167 348.253 519.28 335.306 503.383 335.306C487.487 335.306 474.6 348.253 474.6 364.224C474.6 380.195 487.487 393.142 503.383 393.142Z"
          fill="#3D2BFF"
        />
        <path
          d="M312.36 460.887C308.341 456.835 301.818 456.835 297.799 460.887C293.773 464.939 293.773 471.479 297.799 475.531C319.592 497.432 348.567 509.481 379.395 509.481C410.203 509.481 439.185 497.432 460.978 475.531C465.025 471.486 465.025 464.946 460.992 460.887C456.973 456.835 450.449 456.835 446.416 460.887C430.942 476.419 411.13 485.902 389.698 488.212V449.741C397.41 445.931 402.731 437.962 402.731 428.706C402.731 415.776 392.273 405.255 379.395 405.255C366.489 405.255 356.046 415.769 356.046 428.706C356.046 437.962 361.367 445.931 369.079 449.741V488.212C347.668 485.895 327.828 476.412 312.36 460.887Z"
          fill="#3D2BFF"
        />
        <path
          d="M379.403 25.3854C183.881 25.3854 25.3855 184.618 25.3855 381.05C25.3855 486.911 71.4765 581.917 144.533 647.067V453.557C144.533 397.62 163.949 346.267 196.327 305.826V172.029C196.327 139.727 222.394 113.546 254.546 113.546C286.69 113.546 312.757 139.727 312.757 172.029V227.312C333.885 221.035 356.237 217.616 379.396 217.616C402.541 217.616 424.907 221.042 446.021 227.312V172.029C446.021 139.727 472.087 113.546 504.246 113.546C536.398 113.546 562.451 139.727 562.451 172.029H562.43V305.819C594.822 346.267 614.238 397.62 614.238 453.557V647.096C687.315 581.945 733.421 486.932 733.421 381.05C733.421 184.618 574.925 25.3854 379.403 25.3854Z"
          fill="url(#paint0_linear_114_11)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_114_11"
            x1="379.426"
            y1="716.283"
            x2="379.426"
            y2="25.3854"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D2BFF" />
            <stop offset="1" stopColor="#19A4FE" />
          </linearGradient>
        </defs>
      </svg>
      <p>{t("posts_will_be_published")}</p>
    </div>
  );
};

export default Maintenance;
